import { combineReducers } from "@reduxjs/toolkit";
import salesListReducer from "./sales-list.slice"
import filterSalesReducer from "./filter-sales.slice";

const reducer = combineReducers({
  list: salesListReducer,
  filters: filterSalesReducer,
});

export default reducer;
